<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-line" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">最新风险事件</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        // header: ['事件'],
        data: [
          ['发现船员未穿救生衣行为'],
          ['船舶超高碰撞桥梁进行预警'],
          ['发现内河农（林）自用船舶、渔船的主干航道碍航行为'],
          ['发现船舶配员不足风险'],
          ['发现船员未穿救生衣行为'],
          ['发现船舶非法装卸、或无证“黑码头”经营行为'],
          ['发现内河农（林）自用船舶、渔船的主干航道碍航行为'],
          ['发现船舶未如实报告进出港航次的行为'],
          ['发现船舶超尺度航行行为'],
          ['发现船舶燃油超标行为'],
          ['发现船员未穿救生衣行为'],
          ['发现船舶非法装卸、或无证“黑码头”经营行为'],
          ['发现内河农（林）自用船舶、渔船的主干航道碍航行为'],
          ['发现船舶未如实报告进出港航次的行为'],
          ['发现船舶超尺度航行行为'],
          ['发现船舶燃油超标行为']
        ],
        rowNum: 10, //表格行数
        // headerHeight: 35,
        // headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        index: true,
        columnWidth: [50],
        // align: ['center']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$box-height: 410px;
$box-width: 100%;
#centerRight1 {
  padding: 16px;
  padding-top: 20px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-scr-board {
      width: 100%;
      height: 340px;
    }
  }
}
</style>
